import { render, staticRenderFns } from "./comboGeneral.vue?vue&type=template&id=1df5ea0b&scoped=true"
import script from "./comboGeneral.vue?vue&type=script&lang=js"
export * from "./comboGeneral.vue?vue&type=script&lang=js"
import style0 from "./comboGeneral.vue?vue&type=style&index=0&id=1df5ea0b&prod&lang=scss&scoped=true"
import style1 from "./comboGeneral.vue?vue&type=style&index=1&id=1df5ea0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df5ea0b",
  null
  
)

export default component.exports